import { render, staticRenderFns } from "./mailIcon.vue?vue&type=template&id=a62dddd2&"
import script from "./mailIcon.vue?vue&type=script&lang=js&"
export * from "./mailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports